export interface CategoryItem {
  name: string;
  url: string;
  seq: string;
}

export const categories: CategoryItem[] = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    seq: "cat-shoes-01",
  },
  {
    name: "Hoodies / Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    seq: "cat-hoodies-02",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    seq: "cat-tshirts-03",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    seq: "cat-jackets-04",
  },
  {
    name: "Pants / Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    seq: "cat-pants-05",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    seq: "cat-headwear-06",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    seq: "cat-sets-07",
  },
  {
    name: "Underwear / Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    seq: "cat-underwear-08",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    seq: "cat-jersey-09",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    seq: "cat-accessories-10",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    seq: "cat-bags-11",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    seq: "cat-belts-12",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    seq: "cat-perfumes-13",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    seq: "cat-other-14",
  },
];